<div class="modal-header">
  <h5 class="modal-title">Imagens do Exercício</h5>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">

  <div class="mb-3">
    <input type="file" class="form-control" (change)="onFileChange($event)">
    <button class="btn btn-primary mt-2 w-100" (click)="upload()">
      Upload
    </button>
  </div>

  <div class="row">
    <div class="col-6 col-md-4 mb-3" *ngFor="let img of imagens">
      <div class="card">
        <img [src]="getImagemUrl(img.fileServerName)"
             class="card-img-top img-fluid">

        <div class="card-body p-2 text-center">
          <button class="btn btn-sm btn-danger w-100"
                  (click)="delete(img.id)">
            Remover
          </button>
        </div>
      </div>
    </div>
  </div>

</div>